module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"deletePolicyDialog.events.successfulDeletion":"Successfully deleted the policy \u0027{policyName}\u0027","deletePolicyDialog.title":"Delete Policy","deletePolicyDialog.subtitle":"Please enter the name of this policy to delete it"}}')
  delete Component.options._Ctor
}
